<template>
  <div id="waterleak-pdf">
    <div class="ld-top-container">
      <MemberInfoPdf />
      <WaterLeakLocation />
    </div>
    <LeakEventHistory />
    <div class="ld-table-container">
      <OtherAlertsTable v-if="alert.drainPan" />
      <PastLeakAlertsTable />
    </div>
  </div>
</template>

<script>
import MemberInfoPdf from '@shared/components/leadDetailPdf/shared/MemberInfoPdf.vue';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';
import WaterLeakLocation from './waterleak/WaterLeakLocation.vue';
import LeakEventHistory from './waterleak/LeakEventHistory.vue';
import PastLeakAlertsTable from './waterleak/PastLeakAlertsTable.vue';
import OtherAlertsTable from './waterleak/OtherAlertsTable.vue';

export default {
  name: 'WaterLeakPdf',
  components: {
    OtherAlertsTable,
    PastLeakAlertsTable,
    LeakEventHistory,
    WaterLeakLocation,
    MemberInfoPdf,
  },
  mixins: [leadDetailMixin],
};
</script>
